module.exports = __webpack_public_path__ + "img/a04.e82b8fb3.png";